module.exports = {"cookies":"Cookies","help":"Help","privacy":"Privacy","signInButtonText":"Sign In with an Adobe ID","termsOfUse":"Terms of Use","updated":"UPDATED"}


//////////////////
// WEBPACK FOOTER
// ./src/components/ExpLogin/__localization__/ExpLogin/en_us.json
// module id = 944
// module chunks = 0